import userEvent from '@testing-library/user-event'

const extendedUserEvent = {
  ...userEvent,
  /**
   * @deprecated Prefer userEvent.paste() unless testing scenarios that require inputting one character at a time.
   */
  type: userEvent.type,
}

export { extendedUserEvent as userEvent }
